module.exports = __webpack_public_path__ + "static/media/social.8160713b.jpg";